<template>
  <!-- <v-app>
    <v-main class="secondary">
      <Header />
      <v-container fluid>
        <transition name="fade">
          <router-view />
        </transition>
      </v-container>
    </v-main>
  </v-app> -->
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <!-- <v-main> -->
    <Loader />
    <SnackbarAlert />

    <v-container fluid>
      <DebugButton v-if="$DEBUG" />
      <v-row>
        <v-col class="m-10" cols="12" xs="12" sm="10" md="10" lg="12" xl="8">
          <transition name="fade">
            <!-- <keep-alive> -->
            <router-view :key="$route.fullPath" />
            <!-- </keep-alive> -->
          </transition>
        </v-col>
      </v-row>
    </v-container>
    <!-- </v-main> -->
  </v-app>
</template>

<script>
import Loader from "../src/components/Loader";
import SnackbarAlert from "../src/components/SnackbarAlert";
import DebugButton from "../src/components/DebugButton";
import store from "../src/store/index";
export default {
  name: "App",
  components: {
    Loader,
    SnackbarAlert,
    DebugButton
  },
  mounted() {
    // this.$store.dispatch("omitirValidacion", false);
    store.dispatch("loader", false);
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  },
  data: () => ({
    //
  })
};
</script>
